module.exports = "<svg id=\"39ec55aa-19f5-4d65-9bdb-5b94df589998\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>fb-alt</title><rect x=\"0.06\" width=\"49.94\" height=\"50\" rx=\"5\" ry=\"5\"></rect><path d=\"M30.75,50V33.75h1.88c1,0,2.08,0,3.11,0,.17,0,.45-.19.47-.33.28-2,.53-4,.8-6H30.82c0-1.75-.1-3.44,0-5.11.09-1.2.81-1.76,2-1.89,1-.09,2-.08,2.92-.11h1.38V14.6c-.31,0-.61-.09-.92-.11-2.29-.11-4.6-.41-6.87.27a7.11,7.11,0,0,0-5.18,6.39c-.12,1.82-.09,3.65-.12,5.48,0,.22,0,.45,0,.74H18.64v6.35h5.41V50Z\" style=\"fill:#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fb-alt.svg
// module id = 555
// module chunks = 1